var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#ffd600",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 13V4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 26v-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 5V4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 26V15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 13V4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23 26v-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 23c1.6568 0 3-1.3431 3-3s-1.3432-3-3-3-3 1.3431-3 3 1.3432 3 3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 15c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23 23c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.c8c24e59976630244b07b658a7e4f569.svg";
export { ForwardRef as ReactComponent };